import { IconProps } from "../../types/genereal";
import { IconWrapper } from "../ui/IconWrapper";

export const ExportDataIcon = ({
  width = "24",
  height = "24",
  color = "#1D3E70",
  opacity = "1",
}: IconProps) => {
  return (
    <IconWrapper width={width} height={height} color={color} opacity={opacity}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.00293 20C5.45293 20 4.98226 19.8043 4.59093 19.413C4.1996 19.0217 4.0036 18.5507 4.00293 18V15H6.00293V18H18.0029V15H20.0029V18C20.0029 18.55 19.8073 19.021 19.4159 19.413C19.0246 19.805 18.5536 20.0007 18.0029 20H6.00293Z"
          fill={color}
        />
        <path
          d="M11 4V12.15L8.4 9.55L7 11L12 16L17 11L15.6 9.55L13 12.15V4H11Z"
          fill={color}
        />
      </svg>
    </IconWrapper>
  );
};
